// @core/api/endpoints/resource/resolve_ur_ns.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveURNsRequest,
  ResolveURNsResponse,
} from '../../../types/resource';

const BASE_PATH = '/resource';

/**
 * Resolve URNs to resource previews
 * Resolves one or more URNs to resource previews. Returns a map of URN to resource and lists any URNs that could not be resolved.
 */
export async function ResolveURNs(
  data: ResolveURNsRequest,
  options?: RequestOptions
): Promise<ResolveURNsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/resolve`;
  const requestOptions = options;
  return client.post<ResolveURNsResponse>(requestPath, data, requestOptions);
}
